import { apiFetch } from "./client";
import type { Booking } from "./bookings";

export type InquiryListItem = {
  id: number;
  status: string;
  created_at: string;
  gruppenname: string;
  kontakt: string;
  email: string;
  telefon: string;
  gruppenart: string;
  adresse_strasse: string;
  adresse_plz: string;
  adresse_ort: string;
  adresse_land: string;
  check_in: string;
  check_out: string;
  check_in_time: string;
  check_out_time: string;
  personen_gesamt: number;
  einheiten_wunsch: string;
  nachricht: string;
  rejected_reason: string;
  imported_booking_id: number | null;
};

export type InquiriesFilter = {
  status_filter?: string;
  von?: string;
  bis?: string;
};

export type InquiryCounts = {
  offen: number;
  importiert: number;
  abgelehnt: number;
};

export type PromotePayload = {
  /** Aus dem Einheitenwunsch der Anfrage aufgelöste IDs. */
  einheiten_ids: number[];
  /** Weglassen = Config-Default (ANZAHLUNG_BETRAG). */
  anzahlung_betrag?: number;
  force?: boolean;
  bemerkung_prefix: string;
};

export function fetchInquiries(filter: InquiriesFilter = {}): Promise<InquiryListItem[]> {
  const params = new URLSearchParams();
  if (filter.status_filter) params.set("status_filter", filter.status_filter);
  if (filter.von) params.set("von", filter.von);
  if (filter.bis) params.set("bis", filter.bis);
  const qs = params.toString();
  return apiFetch<InquiryListItem[]>(`/api/inquiries${qs ? `?${qs}` : ""}`);
}

export function fetchInquiryCounts(): Promise<InquiryCounts> {
  return apiFetch<InquiryCounts>("/api/inquiries/counts");
}

export function rejectInquiry(id: number, grund: string): Promise<{ ok: boolean; msg: string }> {
  return apiFetch(`/api/inquiries/${id}/reject`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ grund }),
  });
}

export function deleteInquiry(id: number): Promise<{ ok: boolean; detail: string }> {
  return apiFetch(`/api/inquiries/${id}`, { method: "DELETE" });
}

export function promoteInquiry(id: number, payload: PromotePayload): Promise<Booking> {
  return apiFetch<Booking>(`/api/inquiries/${id}/promote`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
